export default function anonymous(it
) {
var out='';if(it.isShow){out+='<div data-click="goMain" class="document-media__goMain"></div>';}return out;
}